<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* ======== 订单提醒全局通知弹窗样式 ======== */
.order-notify-wrap.el-notification {
  width: 360px;
  padding: 14px 18px 14px 56px;
  border-radius: 10px;
  border: 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

.order-notify-wrap.el-notification:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.18);
}

.order-notify-wrap .el-notification__group {
  margin-left: 0;
  margin-right: 8px;
}

.order-notify-wrap .el-notification__title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #303133;
}

.order-notify-wrap .el-notification__content {
  margin: 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
}

.order-notify-wrap .order-notify-body .on-content {
  color: #303133;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 6px;
  word-break: break-all;
}

.order-notify-wrap .order-notify-body .on-num {
  font-size: 12px;
  color: #909399;
  margin-bottom: 10px;
}

.order-notify-wrap .order-notify-body .on-num span {
  color: #303133;
  font-weight: 600;
  margin-left: 2px;
  letter-spacing: 0.3px;
}

.order-notify-wrap .order-notify-body .on-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px dashed #ebeef5;
  font-size: 12px;
}

.order-notify-wrap .order-notify-body .on-time {
  color: #c0c4cc;
}

.order-notify-wrap .order-notify-body .on-link {
  color: #409eff;
  font-weight: 500;
}

/* 左侧色带 */
.order-notify-wrap::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #909399;
}

.order-notify-wrap.order-notify-t1::before { background: linear-gradient(180deg,#67c23a,#95d475); }
.order-notify-wrap.order-notify-t2::before { background: linear-gradient(180deg,#909399,#b1b3b8); }
.order-notify-wrap.order-notify-t3::before { background: linear-gradient(180deg,#e6a23c,#f3d19e); }
.order-notify-wrap.order-notify-t4::before { background: linear-gradient(180deg,#409eff,#79bbff); }

/* 入场动效 */
@keyframes orderNotifyIn {
  0%   { transform: translateX(40px); opacity: 0; }
  60%  { transform: translateX(-6px); opacity: 1; }
  100% { transform: translateX(0); }
}
.order-notify-wrap.el-notification-fade-enter-active {
  animation: orderNotifyIn 0.45s ease;
}

/* 手机端通知弹窗适配 */
@media (max-width: 767px) {
  .order-notify-wrap.el-notification {
    width: calc(100vw - 24px) !important;
    right: 12px !important;
    top: 8px !important;
    padding: 10px 14px 10px 44px;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  }
  .order-notify-wrap .el-notification__group {
    margin-left: 0;
    margin-right: 0;
  }
  .order-notify-wrap .el-notification__title {
    font-size: 13px;
    margin-bottom: 4px;
    line-height: 1.4;
  }
  .order-notify-wrap .order-notify-body .on-content {
    font-size: 12px;
    line-height: 1.5;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .order-notify-wrap .order-notify-body .on-num {
    font-size: 11px;
    margin-bottom: 6px;
  }
  .order-notify-wrap .order-notify-body .on-foot {
    padding-top: 6px;
    font-size: 11px;
  }
  /* 缩小左侧色带 */
  .order-notify-wrap::before {
    width: 3px;
  }
  /* 关闭按钮缩小 */
  .order-notify-wrap .el-notification__closeBtn {
    top: 6px;
    right: 6px;
    font-size: 14px;
  }
}
</style>
